import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { getToken, LogoutUser } from '@frontend/auth-store';
import { LocalstorageService } from '@frontend/app-config';

@Component({
  selector: 'frontend-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentRoute: string;
  isLoggedIn = false;
  private tokenSub: Subscription;

  constructor(
    private router: Router,
    private store: Store,
    private ls: LocalstorageService
  ) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const url = event.url.split('/').filter((t) => t);
        if (url[0]) {
          this.currentRoute = url[0].indexOf('?') !== -1 ? url[0].substr(0, url[0].indexOf('?')) : url[0];
        } else {
          this.currentRoute = '';
        }
      }
    });
  }

  ngOnInit() {
    this.tokenSub = this.store.select(getToken).subscribe((token) => {
      this.isLoggedIn = !!token;
    });
  }

  ngOnDestroy() {
    this.tokenSub?.unsubscribe();
  }

  buyToken() {
    this.router.navigate(['/purchase-token']);
  }

  logout() {
    this.ls.clearAllLocalStorage();
    this.store.dispatch(LogoutUser());
    this.router.navigate(['/']);
  }
}
